import styled from 'styled-components'
export const StyledExercise = styled.div`
  width: 100%;
  max-width: 900px;
  color: white;
  display: flex;
  flex-direction: column;
  @media (orientation:portrait) {
    flex-direction: column;
    align-items: center;
    display: flex;
  }
`
export const StyledOptionsList = styled.div`
  display:flex;
  flex-direction: column;
  font-size: 1em;
  > * {
    margin-top: 1rem;
  }
  button {
    padding: 0;
  }

`
